// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  title_line1: '',
  title_line2: '',
  description: '',
  video_block_title: '',
  video_link: '',
  rating_block_title: '',
  rating_block_description: '',
  rating_block_carousel_interval: 5000,
  rating_panel: [],
  images: [],
  carbon_block_title: '',
  carbon_block_description: '',
};

const homeReducer = createReducer(initialState, {
  // eslint-disable-next-line no-unused-vars
  [types.REQUEST_PAGE_DATA](state, action) {
    return {
      ...state,
    };
  },
  [types.REQUEST_PAGE_DATA_SUCCESS](state, action) {
    return {
      ...state,
      ...action.data,
    };
  },
});

export default homeReducer;
